import { Clause } from '../../types/policy';

export const clauseExists = (clauses: Clause[], code: string) =>
  !!clauses.find(({ clauseWording }) =>
    clauseWording.find(({ clauseCode }) => clauseCode === code)
  );
